import { get, put, del } from "./api_helper";

// Legacy API functions - Use ApiService for new development
// User Profile API
export const getUserProfileApi = () => {
  return get("/user/profile");
};

export const updateUserProfileApi = (data) => {
  return put("/user/profile", data);
};

// Curriculum API
export const getCurriculumApi = () => {
  return get("/curriculum");
};

export const updateCurriculumApi = (data) => {
  return put("/curriculum", data);
};

export const deleteCurriculumApi = () => {
  return del("/curriculum");
};